import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center text-lg gap-2 h-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, " - ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      ref: "refLeft",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.left) = $event)),
      class: "border border-gray-400 rounded-md outline-none overflow-hidden py-1 px-2 w-16",
      type: "text",
      pattern: "\\d*",
      maxlength: "3",
      inputmode: "decimal",
      placeholder: "123",
      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onLeftInput && _ctx.onLeftInput(...args))),
      onPaste: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onPaste && _ctx.onPaste(...args)))
    }, null, 544), [
      [_vModelText, _ctx.left]
    ]),
    _hoisted_2,
    _withDirectives(_createElementVNode("input", {
      ref: "refRight",
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.right) = $event)),
      class: "border border-gray-400 rounded-md outline-none overflow-hidden py-1 px-2 w-20",
      type: "text",
      pattern: "\\d*",
      maxlength: "4",
      inputmode: "decimal",
      placeholder: "4567",
      onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onRightInput && _ctx.onRightInput(...args))),
      onPaste: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onPaste && _ctx.onPaste(...args)))
    }, null, 544), [
      [_vModelText, _ctx.right]
    ])
  ]))
}